module.exports = __webpack_public_path__ + "img/badge_gowelfare.4fb3bf4b.jpg";